import React from 'react';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import articleModalService from '../../Services/ArticleModal/index.jsx';
class ArticleBookmark extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            busy: false
        };
        this.state = {
            bookmark: this.props.article.bookmarks
        };
        this.addBookmark = this.addBookmark.bind(this)
    }

    addBookmark() {

        if (this.state.busy) return;

        this.setState({
            busy: true
        })
        this.state = {
            bookmark: this.props.article.bookmarks
        };
        let bookmarkArticle = Object.assign({}, this.props.article.analytics)

        fetch(`${window.SBM.ajaxUrl}?action=theme:post-bookmark`, {
            method: 'post',
            body: JSON.stringify({
                id: this.props.article.id
            })
        })
            .then(response => response.json())
            .then(data => {
                if (data.error) {
                    console.error(data.message)
                } else {
                    data = JSON.stringify(data.data.value)

                    if (data.includes(this.props.article.id)) {
                        this.setState({
                            bookmark: true
                        })
                        bookmarkArticle["content_bookmark"] = 'bookmark';
                        CSAnalytics("Article Bookmarked", bookmarkArticle)
                    } else {
                        this.setState({
                            bookmark: false
                        })
                        bookmarkArticle["content_bookmark"] = 'unbookmark';
                        CSAnalytics("Article Unbookmarked", bookmarkArticle)
                    }
                }
                this.setState({
                    busy: false
                })
            })
    }

    render() {
        let temp = 'fa fa-regular';
        if (this.state.bookmark) {
            temp = 'fas fa-solid';
        }
        return (
            <div className="cs-article-bookmark" ><OverlayTrigger overlay={this.overlay()} trigger={['hover','focus']} placement="top"><i className={`${temp} fa-bookmark`} onClick={() => {
                this.addBookmark()
            }}></i></OverlayTrigger></div>
        );
    }

    overlay() {
        let bookmarktxt = 'bookmark';
        if (this.state.bookmark) {
            bookmarktxt = 'unbookmark';
        }
        return (
            <Tooltip>
                {bookmarktxt}
            </Tooltip>
        );
    }
}

export default ArticleBookmark;
